import axios from 'axios';

import { IOrder } from '@/shared/model/order.model';

const baseApiUrl = 'api/orders/calendar';

export default class OrderCalendarService {
  public retrieve(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
